import { render, staticRenderFns } from "./PT436MemberSendDetParts.vue?vue&type=template&id=646febe1&"
import script from "./PT436MemberSendDetParts.vue?vue&type=script&lang=js&"
export * from "./PT436MemberSendDetParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports